import * as React from 'react';

import { SidebarCommonHeaderContainer } from '../SidebarCommonHeaderContainer';

export const SidebarHeaderContainer: React.FC = () => {
  return <SidebarCommonHeaderContainer />;
};

SidebarHeaderContainer.displayName = 'SidebarHeaderContainer';
